








































































































import UserNameInfo from "@/components/utility/UserNameInfo.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IReport } from "@/models/report.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import PartnerReportStatusHistoryAddDialog from "./PartnerReportStatusHistoryAddDialog.vue";
import SideCard from "../utility/SideCard.vue";
import { detailedDate } from "@/lib/utility/date-helper";
import MIconButton from "../utility/mmmint/MIconButton.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import { handleError } from "@/lib/utility/handleError";

@Component({
  components: {
    UserNameInfo,
    PartnerReportStatusHistoryAddDialog,
    SideCard,
    MIconButton,
    ConfirmActionDialog
  },
  filters: { detailedDate }
})
export default class PartnerReportStatusHistoryCard extends mixins(PermissionMixin) {
  @Prop()
  value!: IReport;

  @Prop({ default: "grey lighten-4" })
  color!: string;

  newStatus = "";
  dialog = false;
  isSideCard = false;
  isDeleteDialog = false;
  deleteIndex: number | null = null;
  isDeleteLoading = false;

  get statusHistory() {
    if (!this.value.statusHistory) {
      return [];
    }

    return this.value.statusHistory.slice().reverse();
  }

  get currentStatus() {
    return this.value.statusHistory?.length ? this.value.statusHistory[this.value.statusHistory.length - 1].status : "";
  }

  get currentStatusMinusTwo() {
    if (!this.value.statusHistory) {
      return null;
    }

    return this.value.statusHistory?.length > 2
      ? this.value.statusHistory[this.value.statusHistory.length - 3].status
      : "";
  }

  get currentStatusMinusOne() {
    if (!this.value.statusHistory) {
      return null;
    }

    return this.value.statusHistory?.length > 1
      ? this.value.statusHistory[this.value.statusHistory.length - 2].status
      : "";
  }

  iconColor(i: number) {
    return i === 0 ? "primary" : "black";
  }

  statusColorClass(i: number) {
    if (i !== 0) {
      return;
    }

    return "primary--text";
  }

  /**
   *
   * Deletes the selected status history entry after confirmation.
   */
  startDeleteStatus(i: number) {
    this.deleteIndex = i;
    this.isDeleteDialog = true;
  }

  /**
   *
   */
  async deleteStatus() {
    try {
      if (this.deleteIndex === null) {
        return;
      }

      const orig = this.value?.statusHistory || [];
      if (!orig.length) return;

      this.isDeleteLoading = true;

      const len = orig.length;
      const originalIndex = len - 1 - this.deleteIndex;

      const statusToBeDeleted = orig[originalIndex]?.status;

      const newStatusHistory = orig.slice();
      newStatusHistory.splice(originalIndex, 1);

      await this.value.updatePartial({
        statusHistory: newStatusHistory
      });

      if (statusToBeDeleted && this.canCreateActivity) {
        await this.value.deleteCustomProgressStatusActivityLog(statusToBeDeleted);
      }
      this.isDeleteDialog = false;
      this.deleteIndex = null;

      this.$emit("input", this.value);
    } catch (error) {
      handleError(error);
    } finally {
      this.isDeleteLoading = false;
    }
  }
}
